<template>
  <section>
    <b-row>
      <b-col cols="3" v-if="!hideSearch">
        <b-input-group class="shadow-sm rounded">
          <template slot="prepend">
            <b-button variant="ghost" class="py-0 pl-2 pr-1 bg-white">
              <img src="@/assets/images/search.svg" alt="Search" />
            </b-button>
          </template>
          <b-form-input
            id="inventory-search"
            v-model="keyword"
            placeholder="Search"
            class="border-0"
            @keyup.native="debounceSearch"
          >
          </b-form-input>
        </b-input-group>
      </b-col>
      <b-col cols="3">
        <BrandBranches
          v-if="!branchesLoading"
          @applyBrandsAndBranches="applyBrandsAndBranches"
          errorKey="branch_uuids"
          :brandAndBranchUuids="brandAndBranchUuids"
          formGroupLabel=""
          formGroupClass="secondary-label mb-2 product-creation-labels"
          :bypassMaxWidth="true"
          allSelectedDropdownText="All branches"
          class="border-0 shadow-sm"
        />
      </b-col>
      <b-col class="text-right">
        <b-button
          v-if="
            showEditAddOnsButton &&
            inventoryList.length &&
            inventoryList[0].add_on_category.length
          "
          variant="outline-primary"
          class="btn-pill px-4 mr-3"
          @click="
            $root.$emit('bv::show::modal', 'inventory-view-add-ons-modal')
          "
        >
          Edit Add-Ons
        </b-button>
        <b-button
          variant="primary"
          class="btn-pill px-4"
          :disabled="!selectedItems.length || isLoading"
          @click="$root.$emit('onUpdateInventory')"
        >
          Save All
        </b-button>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import BrandBranches from "@/components/store/BrandBranches";
import _ from "lodash";
import { mapFields } from "vuex-map-fields";
import { mapState } from "vuex";

export default {
  props: {
    hideSearch: {
      type: Boolean,
      default: false,
    },
    showEditAddOnsButton: {
      type: Boolean,
      default: false,
    },
    previousFilters: {
      type: Object,
      default: null,
    },
  },
  components: { BrandBranches },
  data() {
    return {
      keyword: null,
      branch_uuids: [],
      brandAndBranchUuids: [],
      selected_all_brands_branches: false,
    };
  },
  computed: {
    ...mapFields("products", ["pagination", "filters"]),
    ...mapState("products", ["selectedItems", "inventoryList", "isLoading"]),
    ...mapState("branches", {
      branches: (state) => state.branches,
      branchesLoading: (state) => state.loading,
    }),
  },
  created() {
    this.debounceSearch = _.debounce(() => {
      this.getInventoryList();
    }, 500);
  },
  methods: {
    getInventoryList() {
      this.pagination.currentPage = 1;
      this.filters.keyword = this.keyword;
      this.filters.branch_uuids = this.branch_uuids;
      this.$emit("getInventoryList");
    },
    applyBrandsAndBranches(brandAndBranches) {
      const previous_brand_uuids = this.branch_uuids;
      this.branch_uuids = brandAndBranches.map(
        ({ branch_uuid }) => branch_uuid
      );
      // if (previous_brand_uuids.length !== this.branch_uuids.length)
        this.getInventoryList();
    },
  },
  watch: {
    previousFilters(previousFilters) {
      if (previousFilters) {
        this.keyword = previousFilters.keyword;
        this.brandAndBranchUuids = previousFilters.branch_uuids;
        this.$store.dispatch("branches/getBranches", true);
      }
    },
    branches(branches) {
      if (branches.length) {
        this.brandAndBranchUuids = this.branches.filter(({ uuid }) =>
          this.previousFilters.branch_uuids.includes(uuid)
        );
      }
    },
  },
};
</script>

<style scoped>
.btn {
  font-size: 15px;
}
</style>